<template>
    <div class="page-404 d-flex justify-center align-center flex-column">
        <h1 class="text">404 - Страница не существует</h1>
        <v-chip
            class="ma-2"
            color="indigo"
            text-color="white"
            @click="$router.push('/login')">
            <v-avatar left>
                <v-icon>mdi-clipboard-list-outline</v-icon>
            </v-avatar>
            На главную
        </v-chip>
    </div>
</template>
<script>
export default {
    name: '404'
}
</script>
<style scoped>
.page-404 {
    height: 100vh;
}
.text{
    color: #15336d;
    font-weight: bold;
    font-size: 60px;
    padding-bottom: 15px;
  }
</style>